import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';
import { LoginComponent } from './pages/login/login.component';

@NgModule({
    declarations: [LoginComponent],
    imports: [CommonModule, MatDialogModule, ReactiveFormsModule, RouterModule],
})
export class LoginModule {}
